import { colors } from '@mui/material';
import Box from '@mui/material/Box';
import type { TypographyProps } from '@mui/material/Typography';
import Typography from '@mui/material/Typography';
import type { CartItem, PackItem, PackProduct, Product } from '~/services/api.server';

type PackItemProps = {
  item: PackItem;
  variant: TypographyProps['variant'];
  cartItem: CartItem;
  product?: Product;
};

function PackItemComponent({ item, variant, cartItem, product }: PackItemProps) {
  return (
    <Box component="li" key={item.id}>
      <Box component="span">
        <Typography component="span" variant={variant}>
          {product?.name}&nbsp;
        </Typography>
        <Typography component="span" variant={variant} color="text.secondary">
          (
          {cartItem.items_attributes
            ?.find((ia) => ia.product_id === product?.id)
            ?.attributes?.map((a) => a.value)
            .join(', ')}
          )
        </Typography>
      </Box>
    </Box>
  );
}

type PackItemsProps = {
  packProduct: PackProduct;
  cartItem: CartItem;
  variant: TypographyProps['variant'];
};

export function PackItems({ packProduct, cartItem, variant = 'body1' }: PackItemsProps) {
  const containerItem: PackItem = {
    id: packProduct.container.id,
    units_per_pack: 1,
    product: packProduct.container,
  };
  return (
    <Box component="ul" pl={3} mb={0}>
      {packProduct.container && (
        <PackItemComponent
          key={packProduct.container.id}
          item={containerItem}
          variant={variant}
          cartItem={cartItem}
          product={packProduct.container}
        />
      )}
      {packProduct.items.map((item) => {
        const p = item.supplier_product || item.product;
        return <PackItemComponent key={item.id} item={item} variant={variant} cartItem={cartItem} product={p} />;
      })}
    </Box>
  );
}

export function PackBadge({ text = 'PACK' }: { text?: string }) {
  return (
    <Box bgcolor={colors.grey.A200}>
      <Typography fontSize="0.625rem" py={0.5} px={1} color={colors.grey[800]}>
        {text}
      </Typography>
    </Box>
  );
}
